import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES: MijnRoute = {
    path: 'betaalbatches',
    navigationEvent: 'toBetaalbatches',
    regex: /^\/betaalbatches$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent'
};
